import React, { PureComponent } from 'react'
import { View, KeyboardAvoidingView } from 'react-native'
import RNPinInput from 'react-native-smooth-pincode-input'

import styled from 'styled-components/native'

import Touchable from '../../../Atoms/Touchable'
import Icon from '../../../Atoms/Icon'

import HeaderBar from '../../../Molecules/HeaderBar'

import theme from '../../../../styles/theme'

const Container = styled(KeyboardAvoidingView)`
  flex: 1;
  background-color: ${theme.colours.lightgrey};
`

const Body = styled(View)`
  flex: 1;
  padding: ${3 * theme.gutterUnit}px;
  justify-content: center;
  align-items: center;
`

const LargerTouchable = styled(Touchable)`
  height: 100%;
  justify-content: center;
  padding: 15px 20px 20px 15px;
`

const PIN = '7981'

export default class PinInput extends PureComponent {
  state = {
    pin: ''
  }

  pinInput = React.createRef();
  handleCheckCode = (code) => {
    if (code !== PIN) {
      this.pinInput.current.shake()
        .then(() => this.setState({ pin: '' }))
    } else {
      this.props.onComplete()
    }
  }

  render () {
    const { onCancel } = this.props
    return (
      <Container behavior='padding'>
        <HeaderBar transparent>
          <LargerTouchable onPress={onCancel}>
            <Icon name='close' size='xl' />
          </LargerTouchable>
        </HeaderBar>
        <Body>
          <RNPinInput
            ref={this.pinInput}
            autoFocus
            value={this.state.pin}
            onTextChange={pin => this.setState({ pin })}
            onFulfill={this.handleCheckCode}
            keyboardType='number-pad'
          />
        </Body>
      </Container>
    )
  }
}
